import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-spinner',
  standalone: true,
  imports: [],
  templateUrl: './loader-spinner.component.html',
  styleUrl: './loader-spinner.component.scss'
})
export class LoaderSpinnerComponent {

}
